var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    attrs: {
      id: "courseware-action-widget",
      title: _vm.$gettext("Aktionen"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "ul",
              {
                staticClass: "widget-list widget-links cw-action-widget",
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "cw-action-widget-add",
                  },
                  [
                    _c(
                      "button",
                      {
                        on: {
                          click: function click($event) {
                            return _vm.setShowUnitAddDialog(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Lernmaterial hinzufügen")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }